<template>
  <div class="b-percentage-bars">
    <div  v-for="item in chartData.records" :key="item.id" class="b-percentage-bars__item">
      <div class="b-percentage-bars__category">
        {{item.categoryName}}
      </div>
       <div class="b-percentage-bars__bar">
        <span class="b-percentage-bars__progress"  :style="{ width: item.percentage + '%' }"></span>
        <span  class="b-percentage-bars__num">{{item.percentage  + '%'}}</span>
       </div>
    </div>
  </div>
</template>
<script>


export default {
  props: {
    chartData: {
      required: true,
      type: Object,
    },
  }
 
}
</script>
